import { useParams } from "react-router-dom";
import { Stub } from "./Stub";
import { SongView } from "../ws7/song/SongView";
import "../ws7/ws7.css";

/** /songs/:songId (WS7). */
export function SongPage() {
  const { songId } = useParams();
  const id = Number(songId);
  if (!Number.isInteger(id) || id <= 0) return <Stub title="Song not found" owner="nobody" />;
  return <SongView key={id} songId={id} />;
}
